/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanTaskResponseDto
 */
export interface PlanTaskResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PlanTaskResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlanTaskResponseDto
     */
    planId: string;
    /**
     * 
     * @type {string}
     * @memberof PlanTaskResponseDto
     */
    taskId: string;
    /**
     * 
     * @type {string}
     * @memberof PlanTaskResponseDto
     */
    triggerId: string;
    /**
     * 
     * @type {number}
     * @memberof PlanTaskResponseDto
     */
    sequence: number;
    /**
     * 
     * @type {Date}
     * @memberof PlanTaskResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlanTaskResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the PlanTaskResponseDto interface.
 */
export function instanceOfPlanTaskResponseDto(value: object): value is PlanTaskResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('planId' in value) || value['planId'] === undefined) return false;
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('triggerId' in value) || value['triggerId'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PlanTaskResponseDtoFromJSON(json: any): PlanTaskResponseDto {
    return PlanTaskResponseDtoFromJSONTyped(json, false);
}

export function PlanTaskResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanTaskResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'planId': json['planId'],
        'taskId': json['taskId'],
        'triggerId': json['triggerId'],
        'sequence': json['sequence'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function PlanTaskResponseDtoToJSON(json: any): PlanTaskResponseDto {
    return PlanTaskResponseDtoToJSONTyped(json, false);
}

export function PlanTaskResponseDtoToJSONTyped(value?: PlanTaskResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'planId': value['planId'],
        'taskId': value['taskId'],
        'triggerId': value['triggerId'],
        'sequence': value['sequence'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

